angular.module('dpw.components').component('dpwInstallBotButton', {
    templateUrl: 'dpw-install-bot-button.component.html',
    controllerAs: 'ctrl',
    bindings: {
        actionEnabledInProd: '<',
        appKey: '<',
        application: '<',
        botInfo: '<',
        canManipulateApp: '<',
        onAuthorize: '&',
        onUpdateBotInfo: '&',
        onRefreshStatus: '&'
    },
    controller: ['$scope', 'api', 'trackUtil', 'popup', 'botErrorHandler', 
        function ($scope, api, trackUtil, popup, botErrorHandler) {
            var self = this;
            var env = 'prod';

            self.openInstallDialog = function () {
                if (self.actionEnabledInProd) {
                    trackUtil.logPageView('InstallBot:' + env);

                    api.call(api.botProvision.getConfirmation({
                        appId: self.appKey.id
                    }), function (data) {
                        if (data.isAbleToInstall) {
                            var newScope = $scope.$new();
                            newScope.config = {
                                appIconUrl: _.get(self, 'application.iconUrl', ''),
                                app: self.application,
                                appKey: self.appKey,
                                permissions: data.permissions,
                                onClose: function () {
                                    newScope.$destroy();
                                },
                                onSubmit: function (appKeyId, botName, popupCtrl) {
                                    self.onAuthorize({
                                        appKeyId: appKeyId,
                                        botName: botName,
                                        popupCtrl: popupCtrl
                                    });
                                }
                            };
                            popup({
                                scope: newScope,
                                directiveName: 'dpw-bot-installation-confirmation',
                                showHeader: 'false',
                                extraClass: 'popup-auto-width console-ui my-account popup-absolute'
                            });
                        } else if (data.reasons && data.reasons.length > 0) {
                            popupErrorMsg(data.reasons[0], env);
                        } else if (data.isExist) {
                            self.onUpdateBotInfo({ botInfo: data.botExtension });
                            popupErrorMsg('BOT_ALREADY_INSTALLED', env);
                        }
                    }, function (res, defaultHandler) {
                        if (res.status && res.status.message === 'BOT_BRAND_NOT_SUPPORTED') {
                            popupErrorMsg(res.status.message, env);
                        } else {
                            defaultHandler();
                        }
                    });
                }
            };

            function popupErrorMsg(errorType, env) {
                botErrorHandler.popupMsg(errorType, $scope, self, env, self.onRefreshStatus);
            }
    }]
});
